import {NgModule} from '@angular/core';
import {CaptchaComponent} from "@iw-shared/captcha/componments/captcha/captcha.component";
import {CommonModule} from "@angular/common";
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";

@NgModule({
  declarations: [
    CaptchaComponent,
  ],
  imports: [
    CommonModule,
    FontAwesomeModule
  ],
  exports: [
    CaptchaComponent
  ]
})
export class CaptchaModule {
}
